var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebhook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129 120.1",
    style: {
      enableBackground: "new 0 0 129 120.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C73A63;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#4B4B4B;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#4A4A4A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "OvHZFw.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.5,50.3c-5.4,9-10.5,17.8-15.8,26.4c-1.3,2.2-2,4-0.9,6.9c3,7.8-1.2,15.4-9.1,17.5 c-7.4,1.9-14.7-2.9-16.2-10.9c-1.3-7,4.2-14,11.9-15.1c0.7-0.1,1.3-0.1,2.4-0.2c3.8-6.4,7.7-12.9,11.8-19.8 c-7.4-7.4-11.9-16-10.9-26.7c0.7-7.6,3.7-14.1,9.1-19.5c10.4-10.3,26.3-11.9,38.6-4C93.2,12.5,98.6,27.2,94,39.9 c-3.5-0.9-7-1.9-10.8-2.9c1.4-7,0.4-13.3-4.4-18.7c-3.1-3.6-7.1-5.4-11.7-6.1c-9.1-1.4-18.1,4.5-20.8,13.5 C43.4,35.8,48,44.1,60.5,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.8,39.7c3.8,6.7,7.6,13.4,11.4,20.1c19.2-6,33.7,4.7,38.9,16.1c6.3,13.8,2,30.1-10.4,38.6 c-12.7,8.7-28.7,7.2-39.9-4c2.9-2.4,5.7-4.8,8.8-7.4c11.1,7.2,20.8,6.8,28-1.7c6.1-7.3,6-18.1-0.3-25.2c-7.3-8.2-17-8.4-28.8-0.6 c-4.9-8.7-9.9-17.3-14.6-26c-1.6-2.9-3.4-4.7-7-5.3c-6-1-9.9-6.2-10.1-12c-0.2-5.7,3.1-10.9,8.4-12.9c5.2-2,11.3-0.4,14.9,4.1 c2.9,3.6,3.8,7.7,2.3,12.2C76.9,37,76.4,38.2,75.8,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.8,94.2c-7.6,0-15.2,0-23.2,0c-2.2,9.1-7,16.5-15.3,21.2c-6.4,3.6-13.3,4.9-20.7,3.7 c-13.6-2.2-24.6-14.4-25.6-28.1C-1,75.4,9.7,61.5,23.9,58.4c1,3.6,2,7.2,3,10.8C13.8,75.8,9.3,84.3,13,94.8 c3.2,9.3,12.4,14.3,22.3,12.4c10.2-2,15.3-10.4,14.7-24c9.6,0,19.3-0.1,28.9,0c3.8,0.1,6.7-0.3,9.5-3.6c4.7-5.5,13.2-5,18.3,0.2 c5.1,5.3,4.9,13.7-0.5,18.8c-5.2,4.9-13.5,4.6-18.4-0.6C86.6,96.8,85.8,95.5,84.8,94.2z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhook);
export default __webpack_public_path__ + "static/media/webhook.d325bb282090e475b38d379ec44ce4cb.svg";
export { ForwardRef as ReactComponent };